/* eslint-disable camelcase -- Firestore alan adları mevcut veri sözleşmesidir. */
type SearchIndexableUser = {
  arama_motoru_gorunur_mu?: boolean;
  verified_account?: boolean;
  log_toplam_mac?: number;
  galibiyet?: number;
  maglubiyet?: number;
};

type SearchIndexableContent = {
  seo_indeksle?: boolean;
};

export const isContentSearchIndexable = (
  content: SearchIndexableContent,
  isActive = true,
): boolean => isActive && content.seo_indeksle !== false;

/**
 * Arama sonuçlarına yalnızca gerçek maç geçmişi bulunan, doğrulanmış ve
 * görünürlüğü kapatılmamış oyuncu profillerini gönderir.
 */
export const isProfileSearchIndexable = (user: SearchIndexableUser): boolean => {
  const matchCount = Math.max(
    Number(user.log_toplam_mac) || 0,
    (Number(user.galibiyet) || 0) + (Number(user.maglubiyet) || 0),
  );

  return user.arama_motoru_gorunur_mu !== false && user.verified_account === true && matchCount > 0;
};

export const toSchemaDate = (value: unknown): string | undefined => {
  if (value === null || value === undefined || value === '') return undefined;

  let date: Date;
  if (typeof (value as { toDate?: unknown }).toDate === 'function') {
    date = (value as { toDate: () => Date }).toDate();
  } else if (typeof value === 'object' && !(value instanceof Date)) {
    const timestamp = value as { seconds?: number; _seconds?: number };
    // eslint-disable-next-line no-underscore-dangle -- Serialized Admin SDK timestamps.
    const seconds = timestamp.seconds ?? timestamp._seconds;
    if (typeof seconds !== 'number') return undefined;
    date = new Date(seconds * 1000);
  } else if (typeof value === 'number') {
    date = new Date(value < 10_000_000_000 ? value * 1000 : value);
  } else if (typeof value === 'string' || value instanceof Date) {
    date = new Date(value);
  } else {
    return undefined;
  }

  return Number.isNaN(date.getTime()) ? undefined : date.toISOString();
};

/** Never claim a future content update in a sitemap. */
export const sitemapLastmodTag = (value: unknown): string => {
  const date = toSchemaDate(value);
  return date && Date.parse(date) <= Date.now() ? `\n    <lastmod>${date}</lastmod>` : '';
};

/** HTML's script parser recognizes closing tags even inside JSON strings. */
export const serializeJsonLd = (value: unknown): string =>
  JSON.stringify(value).replace(/</g, '\\u003c');

export const canonicalUrl = (path: string): string => {
  const pathname = path.split(/[?#]/)[0].replace(/\/+$/, '') || '/';
  return `https://tenis.io${pathname.startsWith('/') ? pathname : `/${pathname}`}`;
};
